// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ok-btn[data-v-7d327f26]{width:100%;margin-top:10px;height:40px;cursor:pointer;border-radius:10px;color:#fff;background-color:#20b2aa;border:1px solid #20b2aa}", ""]);
// Exports
module.exports = exports;
